import NoOrg from './NoOrg'

export default NoOrg
